module.exports = __webpack_public_path__ + "img/7.52aaed39.jpg";